import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Loading from "common/components/loading";
import request from "common/request";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input } from "reactstrap";
import AddImpressions from "./add-impressions";

const propTypes = {
  fetchCampaignPackagesPath: PropTypes.string,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  eligibleImpressionBoosts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      impression_quantity: PropTypes.number,
      cost: PropTypes.number
    })
  )
};

const AddWeeksModal = ({
  fetchCampaignPackagesPath = "",
  isOpen = false,
  toggle,
  onSubmit,
  eligibleImpressionBoosts = []
}) => {
  const [fetchingPackages, setFetchingPackages] = useState(false);
  const [error, setError] = useState(false);
  const [campaignPackages, setCampaignPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedImpression, setSelectedImpression] = useState(null);

  const fetchCampaignPackages = async () => {
    setFetchingPackages(true);
    try {
      const response = await request.get(fetchCampaignPackagesPath);
      setCampaignPackages(response.data);
      setSelectedPackage(response.data[0]);
    } catch (_error) {
      setError(true);
    } finally {
      setFetchingPackages(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchCampaignPackages();
    } else {
      setSelectedImpression(null);
      setSelectedPackage(null);
      setCampaignPackages([]);
      setError(false);
    }
  }, [isOpen]);

  const handleFormSubmit = event => {
    event.preventDefault();
    onSubmit(event, selectedPackage, selectedImpression);
  };

  const renderError = () => (
    <ModalBody className="p-4">
      <h5 className="text-center text-danger">
        Failed to fetch options. Please try again or contact support.
      </h5>
    </ModalBody>
  );

  const renderLoading = () => (
    <ModalBody className="p-4">
      <Loading loading={fetchingPackages} size={3} />
      <h5 className="text-center mb-4">Loading your options...</h5>
    </ModalBody>
  );

  const renderForm = () => (
    <form onSubmit={handleFormSubmit}>
      <ModalBody className="px-4 py-0">
        <h5 className="text-center">How many additional weeks do you want?</h5>
        <hr />
        {campaignPackages.map(campaignPackage => (
          <Label className="d-block pl-4" key={campaignPackage.id} check>
            <Input
              type="radio"
              name="packageSelection"
              onChange={() => setSelectedPackage(campaignPackage)}
              checked={selectedPackage && selectedPackage.id === campaignPackage.id}
            />
            {campaignPackage.radio_label}
          </Label>
        ))}
        {eligibleImpressionBoosts.length > 0 && (
          <AddImpressions
            boostOptions={eligibleImpressionBoosts}
            onSelect={setSelectedImpression}
          />
        )}
      </ModalBody>
      <ModalFooter className="pt-2 px-4">
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button disabled={!selectedPackage} color="primary" type="submit">
          Continue
        </Button>
      </ModalFooter>
    </form>
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} fade={false} className="add-weeks-modal">
      <ModalHeader toggle={toggle} className="p-2" />
      {error && renderError()}
      {fetchingPackages && renderLoading()}
      {campaignPackages.length > 0 && !fetchingPackages && renderForm()}
    </Modal>
  );
};

AddWeeksModal.propTypes = propTypes;

export default AddWeeksModal;
